import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { OverdueAfterSuccessPeriod } from 'mbs-ui-shared@models/backup/schedule-models';

export type overdueSettingsParams = {
  planIds?: { planId: string; computerHid: string }[];
  filter?: {
    search: string;
    companyId: string;
    computerHid: string;
    statusFilter: 'All' | 'IssueOnly' | 'Running';
  };
  overdueSettings: {
    enabled: boolean;
    amount: number;
    period: OverdueAfterSuccessPeriod;
  };
};

@Injectable({
  providedIn: 'root'
})
export class OverdueService {
  private http = inject(HttpClient);

  overdueSettings(params: overdueSettingsParams, isSelected: boolean) {
    return this.http.put(`api/monitoring/${isSelected ? 'group' : 'bulk'}/overdueSettings`, params);
  }
}
